// Consts visuais + helpers compartilhados de charges.
// Story 4.10 extraiu pra reuso entre lista (/charges) e detalhe (/charges/:id).

export const CHARGE_TYPE_LABEL: Record<string, string> = {
  recorrente: 'Recorrente',
  implantacao: 'Implantação',
  consultoria_extra: 'Consultoria',
  treinamento: 'Treinamento',
  desenvolvimento_personalizado: 'Dev. personalizado',
  taxa_setup: 'Setup',
  proration_upgrade: 'Upgrade (proporcional)',
  acordo_quitacao: 'Acordo',
  outro: 'Outro',
};

/**
 * Lastro contábil de NF avulsa (emissão standalone cria charge fantasma
 * paga_manual pra registrar recebimento externo). Não é cobrança enviada ao
 * cliente — UI rotula como "NF avulsa" pra não parecer cobrança comum.
 */
export function isStandaloneFiscalCharge(charge: {
  type: string;
  paymentMethod: string | null;
}): boolean {
  return charge.type === 'outro' && charge.paymentMethod === 'external';
}

/** Label do tipo ciente do lastro de NF avulsa. */
export function chargeTypeLabel(charge: { type: string; paymentMethod: string | null }): string {
  if (isStandaloneFiscalCharge(charge)) return 'NF avulsa';
  return CHARGE_TYPE_LABEL[charge.type] ?? charge.type;
}

export const CHARGE_STATUS_DOT: Record<string, string> = {
  prevista: 'bg-muted-2 ring-muted-3/15',
  enviada: 'bg-warn ring-warn/15',
  paga: 'bg-good ring-good/15',
  paga_manual: 'bg-good ring-good/15',
  vencida: 'bg-bad ring-bad/15',
  failed: 'bg-bad ring-bad/15',
  em_disputa: 'bg-bad ring-bad/15',
  estornada: 'bg-muted-2 ring-muted-3/15',
  liquidada_em_acordo: 'bg-good ring-good/15',
  write_off: 'bg-muted-2 ring-muted-3/15',
};

export const CHARGE_STATUS_LABEL: Record<string, string> = {
  prevista: 'Prevista',
  enviada: 'Enviada',
  paga: 'Paga',
  paga_manual: 'Paga (manual)',
  vencida: 'Vencida',
  failed: 'Falhou',
  em_disputa: 'Em disputa',
  estornada: 'Estornada',
  liquidada_em_acordo: 'Acordo liquidado',
  write_off: 'Write-off',
};

/** Formata string Decimal como moeda BRL. */
export function formatAmountBR(amount: string): string {
  const num = Number(amount);
  if (!Number.isFinite(num)) return amount;
  return num.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/**
 * Status onde marcação manual de pagamento é permitida (story 4.7).
 * Status finais já consolidados não permitem (use refund pra reverter).
 */
export function canMarkPaidManual(status: string): boolean {
  return status === 'enviada' || status === 'vencida' || status === 'prevista';
}

/**
 * Status onde adiar vencimento faz sentido (story 4.8).
 * Boleto precisa ter asaas_payment_id — geralmente status enviada/vencida.
 */
export function canUpdateDueDate(status: string): boolean {
  return status === 'enviada' || status === 'vencida';
}

/** Story 4.9 — só charges em failed podem ser reprocessadas. */
export function canRetry(status: string): boolean {
  return status === 'failed';
}

/**
 * Story 4.11 — só charges pagas aceitam refund (manual no MVP).
 * Pagamento Asaas (status=paga) ou manual (status=paga_manual).
 */
export function canRefund(status: string): boolean {
  return status === 'paga' || status === 'paga_manual';
}

/**
 * Story 4.12 — charge em disputa permite "Aceitar perda" (POST endpoint)
 * ou contestação externa via link Asaas.
 */
export function isInChargebackDispute(status: string): boolean {
  return status === 'em_disputa';
}
